import fetch from "./request.js";

export default {
	checklist(data){
	    return fetch.post("/member/checklist",data)
	},
	checkdel(data){
	    return fetch.post("/member/checkdel",data)
	},
	dsjcx(data){
	    return fetch.post("/member/dsjcx",data)
	},
	dsjurl(data){
	    return fetch.post("/member/dsjurl",data)
	},
    dsjGjQuery(data){
        return fetch.post("/DsjGj/dsjGjQuery",data)
    },
    selectZxSqsJb(data){
        return fetch.post("/ShenzhenHuarong/selectZxSqsJb",data)
    },
    selectWtdbJb(data){
        return fetch.post("/ShenzhenHuarong/selectWtdbJb",data)
    },
    createCreditReportingMaterials(data){
        return fetch.post("/ShenzhenHuarong/createCreditReportingMaterials",data)
    },
    applyForCreditInquiryQuery(data){
        return fetch.post("/ShenzhenHuarong/applyForCreditInquiryQuery",data)
    },
    getApplyForCreditInquirySubmit(data){
        return fetch.post("/ShenzhenHuarong/getApplyForCreditInquirySubmit",data)
    },
    applyForCreditInquiry(data){
        return fetch.post("/ShenzhenHuarong/applyForCreditInquiry",data)
    },
    loanDeductionSubmit(data){
        return fetch.post("/Shop/loanDeductionSubmit",data)
    },
    createAntChainProductSubmit(data){
        return fetch.post("/AntChain/createAntChainProductSubmit",data)
    },
    createAntChainProduct(data){
        return fetch.post("/AntChain/createAntChainProduct",data)
    },
    antChainCancelOrderQuery(data){
        return fetch.post("/AntChain/antChainCancelOrderQuery",data)
    },
    antChainQueryTradeSubmit(data){
        return fetch.post("/AntChain/antChainQueryTradeSubmit",data)
    },
    antChainCloseOrderSubmit(data){
        return fetch.post("/AntChain/antChainCloseOrderSubmit",data)
    },
    antChainCancelContractSubmit(data){
        return fetch.post("/AntChain/antChainCancelContractSubmit",data)
    },
    antChainCancelBathOrderSubmit(data){
        return fetch.post("/AntChain/antChainCancelBathOrderSubmit",data)
    },
    antChainCancelOrderSubmit(data){
        return fetch.post("/AntChain/antChainCancelOrderSubmit",data)
    },
    antChainCancelOrder(data){
        return fetch.post("/AntChain/antChainCancelOrder",data)
    },
    getAntChainPayUrl(data){
        return fetch.post("/AntChain/getAntChainPayUrl",data)
    },
    loveSigningConfig(data){
        return fetch.post("/Shop/loveSigningConfig",data)
    },
    signCancel(data){
        return fetch.post("/Sign/signCancel",data)
    },
    getMemberRz(data){
        return fetch.post("/Sign/getMemberRz",data)
    },
    signDeductionSubmit(data){
        return fetch.post("/Sign/signDeductionSubmit",data)
    },
    getMemberSign(data){
        return fetch.post("/Sign/getMemberSign",data)
    },
    signGetList(data){
        return fetch.post("/Sign/getList",data)
    },
    orderSign(data){
        return fetch.post("/Sign/orderSign",data)
    },
    uploadKeepImg(data) {
        return fetch.post('/Order/uploadKeepImg', data)
    },
    keepOnRecord(data) {
        return fetch.post('/Order/getKeepImg', data)
    },
	offlinefinish(data){
		 return fetch.post('/Order/offlinefinish', data)
	},
    linHaiGzRevocation(data) {
        return fetch.post('/LinhaiCertification/revocationGz', data)
    },
    getLinHaiGzStatus(data) {
        return fetch.post('/LinhaiCertification/getLinHaiGzStatus', data)
    },
    linhaiCreateGzSubmit(data) {
        return fetch.post('/LinhaiCertification/linhaiCreateGzSubmit', data)
    },
    linhaiCreateGz(data) {
        return fetch.post('/LinhaiCertification/linhaiCreateGz', data)
    },
    linhaiUploadFileSubmit(data) {
        return fetch.post('/LinhaiCertification/linhaiUploadFileSubmit', data)
    },
    linhaiUploadFile(data) {
        return fetch.post('/LinhaiCertification/linhaiUploadFile', data)
    },
    getSupprojOrdersList(data) {
        return fetch.post('/SupplierGoodOrders/getSupprojOrdersList', data)
    },
    supplierOrdersList(data) {
        return fetch.post('/SupplierGoodOrders/list', data)
    },
    delSupplier(data) {
        return fetch.post('/shopSupplier/del', data)
    },
    setPassword(data) {
        return fetch.post('/shopSupplier/setPassword', data)
    },
    getSupplier(data) {
        return fetch.post('/shopSupplier/getSupplier', data)
    },
    supplierSetStatus(data) {
        return fetch.post('/shopSupplier/supplierSetStatus', data)
    },
    supplierSubmit(data) {
        return fetch.post('/shopSupplier/saveSupplier', data)
    },
    getShopSupplierList(data) {
        return fetch.post('/shopSupplier/list', data)
    },
    getSystemConfig(data) {
        return fetch.post('/Finance/systemManagement', data)
    },
    getzxhb(data) {
        return fetch.post('/order/getzxhb', data)
    },
    getzxhb2(data) {
        return fetch.post('/order/getzxhb2', data)
    },
    getdbht(data) {
        return fetch.post('/order/getdbht', data)
    },
    getdbht2(data) {
        return fetch.post('/order/getdbht2', data)
    },

	getzrht(data) {
        return fetch.post('/order/getzrht', data)
    },
    getzrht2(data) {
        return fetch.post('/order/getzrht2', data)
    },
    addupzx(data) {
        return fetch.post('/order/addupzx', data);
    },
	addzlht(data){
		return fetch.post('/order/addzlht', data);
	},
	getzlht(data) {
	    return fetch.post('/order/getzlht', data)
	},
	getzlht2(data) {
	    return fetch.post('/order/getzlht2', data)
	},
    exeCertQuery(data) {
        return fetch.post('/GoldExecute/exeCertQuery', data);
    },
    restOrder(data) {
        return fetch.post('/GoldExecute/restOrder', data);
    },
    submitOrder(data) {
        return fetch.post('/GoldExecute/submitOrder', data);
    },
    attachmentPushSubmit(data) {
        return fetch.post('/GoldExecute/attachmentPushSubmit', data);
    },
    attachmentPush(data) {
        return fetch.post('/GoldExecute/attachmentPush', data);
    },
    thoughtOrderInfoSubmit(data) {
        return fetch.post('/GoldExecute/thoughtOrderInfoSubmit', data);
    },
    thoughtOrderInfo(data) {
        return fetch.post('/GoldExecute/thoughtOrderInfo', data);
    },
    businessQuery(data) {
        return fetch.post('/GoldExecute/businessQuery', data);
    },
    inputBusiness(data) {
        return fetch.post('/GoldExecute/inputBusiness', data);
    },
    inputFilesSubmit(data) {
        return fetch.post('/GoldExecute/inputFilesSubmit', data);
    },
    inputFiles(data) {
        return fetch.post('/GoldExecute/inputFiles', data);
    },
    inputShopSubmit(data) {
        return fetch.post('/GoldExecute/inputShopSubmit', data);
    },
    inputShop(data) {
        return fetch.post('/GoldExecute/inputShop', data);
    },

    cxGzSelectBook(data) {
        return fetch.post('/GoldCert/cxGzSelectBook', data);
    },
    resGZ(data) {
        return fetch.post('/GoldCert/resGZ', data);
    },
    cxGzShowVideo(data) {
        return fetch.post('/GoldCert/cxGzShowVideo', data);
    },
    cxCreateGzBookSubmit(data) {
        return fetch.post('/GoldCert/cxCreateGzBookSubmit', data);
    },
    cxCreateGzBook(data) {
        return fetch.post('/GoldCert/cxCreateGzBook', data);
    },
    cxUploadFileSubmit(data) {
        return fetch.post('/GoldCert/cxUploadFileSubmit', data);
    },
    cxUploadFile(data) {
        return fetch.post('/GoldCert/cxUploadFile', data);
    },
    cxOrderInputSubmit(data) {
        return fetch.post('/GoldCert/cxOrderInputSubmit', data);
    },
    cxOrderInput(data) {
        return fetch.post('/GoldCert/getOrderInput', data);
    },
    childShopConfigNumLog(data) {
        return fetch.post('/LimitConfiguration/childShopConfigNumLog', data);
    },
    childShopConfigNumSubmit(data) {
        return fetch.post('/LimitConfiguration/childShopConfigNumSubmit', data);
    },
    limitConfigurationGetChildNum(data) {
        return fetch.post('/LimitConfiguration/childShopConfigNum', data);
    },
    limitConfigurationLog(data) {
        return fetch.post('/LimitConfiguration/getSelfConfigNumsLog', data);
    },
    limitConfigurationShopList(data) {
        return fetch.post('/LimitConfiguration/getShopList', data);
    },
    limitConfigurationSubmit(data) {
        return fetch.post('/LimitConfiguration/setConfigNumSubmit',data);
    },
    setSelfShopConfigNums(data){
        return fetch.post('/LimitConfiguration/setSelfShopConfigNums',data);
    },
    getSelfShopConfigNums(data){
        return fetch.post('/LimitConfiguration/getSelfShopConfigNums',data);
    },
    initViewData(data) {
        return fetch.post('/LimitConfiguration/initViewData',data);
    },
    yqbConfigSubmit(data) {
        return fetch.post('/shop/yqbconfig', data);
    },
    updateqishu(data) {
        return fetch.post('/order/updateqishu',data);
    },
	updateqishu2(data) {
	    return fetch.post('/order/updateqishu2',data);
	},
    getqishu(data) {
        return fetch.post('/order/getqishu', data);
    },
    delorder(data) {
        console.log * (data)
        return fetch.post('/order/delorder', data);
    },
    getgengzhng(data) {
        console.log * (data)
        return fetch.post('/order/getgengzhng', data);
    },
    getDelivernote(data) {
        console.log * (data)
        return fetch.post('/order/getDelivernote', data);
    },
    uploadDelivernote(data) {
        console.log * (data)
        return fetch.post('/order/uploadDelivernote', data);
    },
    gogz(data) {
        console.log * (data)
        return fetch.post('/order/gogz', data);
    },
    // 去认证获取认证信息
    gzdetails(data) {
        console.log * (data)
        return fetch.post('/order/gzdetails', data)
    },
    cardlist(data) {
        console.log * (data)
        return fetch.post('/card/cardlist', data)
    },
    zxquery(data) {
        console.log * (data)
        return fetch.post('/order/zxquery', data)
    },
    qxall(data) {
        console.log * (data)
        return fetch.post('/order/qxall', data)
    },
    zxupd(data) {
        console.log * (data)
        return fetch.post('/order/zxupd', data)
    },
    shopLegalPersonSave(data) {
        return fetch.post('/shop/saveLegalPerson', data)
    },
    shopEditLegalPerson(data) {
        return fetch.post('/shop/editLegalPerson', data)
    },
    setPaymentSubmit(data) {
        console.log * (data)
        return fetch.post('/shop/setPaymentSubmit', data)
    },
    updshop(data) {
        console.log * (data)
        return fetch.post('/shop/updshop', data)
    },
    updshop2(data) {

        return fetch.post('/shop/updshop2', data)
    },
    addsq(data) {
        return fetch.post('/order/addsq', data)
    },
    addfk(data) {
        return fetch.post('/order/addfk', data)
    },
    addht(data) {
        return fetch.post('/order/addht', data)
    },
    getht(data) {
        return fetch.post('/order/getht', data)
    },
    getht2(data) {
        return fetch.post('/order/getht2', data)
    },
    getht3(data) {
        return fetch.post('/order/getht3', data)
    },
    getgzurl(data) {
        return fetch.post('/order/gzurl', data)
    },
    getfk(data) {
        return fetch.post('/order/getfk', data)
    },
    saveqs(data) {
        return fetch.post('/order/saveqs', data)
    },
	saveqs2(data) {
	    return fetch.post('/order/saveqs2', data)
	},
    //获取首页展示数据数量
    getHomeList(data) {
        return fetch.post('/Manage/getObtainStatistic', data)
    },
    //获取日月年数据
    getIncome(data) {
        return fetch.post('/Manage/getIncome', data)
    },

    //修改店铺密码
    shopPwdUpdate(data) {
        return fetch.post('/shop/shopPwdUpdate', data)
    },

    //登录
    checkLogin(data) {
        console.log('11111');
        return fetch.post('/Login/checkLogin', data)
    },
    //获取自己权限列表
    getMyselfNav(data) {
        return fetch.post('/Manage/getNowMemberNav', data)
    },
    //获取所有权限列表
    getNowMemberNav(data) {
        return fetch.post('/AdminNav/getMemberNav', data)
    },
	yslist(data) {
	    return fetch.post('/Member/yslist', data)
	},
	ysdel(data) {
	    return fetch.post('/Member/ysdel', data)
	},
    //添加修改权限列表
    addModifyAdminMenu(data) {
        return fetch.post('/AdminNav/addModifyAdminMenu', data)
    },
    //删除权限列表
    delAdminMenu(data) {
        return fetch.post('/AdminNav/delAdminMenu', data)
    },
    //获取管理员角色列表
    getAdminRole(data) {
        return fetch.post('/common/getRoleInfoList', data)
    },
    //添加修改角色列表
    addModifyAdminRole(data) {
        return fetch.post('/common/roleMenuSave', data)
    },
    //修改角色权限列表
    modifyRoleMenu(data) {
        return fetch.post('/common/roleMenuSave', data)
    },
    //获取管理员列表
    getAdminList(data) {
        return fetch.post('/manage/index', data)
    },
    //添加修改管理员
    addModifyAdmin(data) {
        return fetch.post('/common/adminInfoSave', data)
    },
    //修改管理员密码
    modifyAdminPassword(data) {
        return fetch.post('/manage/adminPassWordUpdate', data)
    },
	optpass(data) {
	    return fetch.post('/manage/optpass', data)
	},
    // //商品分类列表
    // getCategoryList(data) {
    // 	return fetch.post('/goods/getCategoryList', data)
    // },
    //商品分类信息
    getGoodsSaveCategoryList(data) {
        return fetch.post('/goods/getGoodsSaveCategoryList', data)
    },
    //商品分类添加修改
    categoryInfoSave(data) {
        return fetch.post('/goods/categoryInfoSave', data)
    },
    //分类删除
    categoryDelete(data) {
        return fetch.post('/goods/categoryDelete', data)
    },


    // 商品列表
    getGoodsList(data) {
        return fetch.post('/goods/getGoodsList', data)
    },
    //商品基本详情添加
    goodsInfoCreate(data) {
        return fetch.post('/goods/goodsInfoCreate', data)
    },
    //商品基本详情修改
    goodsInfoEdit(data) {
        return fetch.post('/goods/goodsInfoEdit', data)
    },
    //商品基本详情
    getGoodsBaseDetails(data) {
        return fetch.post('goods/getGoodsBaseDetails', data)
    },

    //商品颜色信息
    getGoodsDetails(data) {
        return fetch.post('/goods/getGoodsDetails', data)
    },
    //添加商品颜色信息
    goodsDetailsCreate(data) {
        return fetch.post('/goods/goodsDetailsCreate', data)
    },
    //修改商品颜色信息
    goodsDetailsEdit(data) {
        return fetch.post('/goods/goodsDetailsEdit', data)
    },

    //商品内存及价格信息
    getGoodsDetailsSon(data) {
        return fetch.post('/goods/getGoodsDetailsSon', data)
    },
    //添加商品内存及价格信息
    goodsDetailsSonCreate(data) {
        return fetch.post('/goods/goodsDetailsSonCreate', data)
    },
    //修改商品内存及价格信息
    goodsDetailsSonEdit(data) {
        return fetch.post('/goods/goodsDetailsSonEdit', data)
    },

    //文件上传
    uploadFiles(data) {
        return fetch.post('/goods/uploadFiles', data)
    },

    //用户列表
    getMemberList(data) {
        return fetch.post('/member/getMemberList', data)

    },
    handleChangeYwy(data){
        return fetch.post('/member/handleChangeYwy', data)
    },

    //修改用户字段信息
    updateMemberAttr(data) {
        return fetch.post('/member/updateAttr', data)

    },
    //推广系谱
    getMemberXipu(data) {
        return fetch.post('/Member/getMemberXipu', data)
    },
    //获取协议信息
    getAllXieyi(data) {
        return fetch.post('/manage/getAllXieyi', data)
    },
    //修改协议信息
    updateXieyi(data) {
        return fetch.post('/manage/updateXieyi', data)
    },

    //引导词列表
    getAdvertiseList(data) {
        return fetch.post('/common/getAdvertiseList', data)
    },
    //引导词添加修改
    advertiseInfoSave(data) {
        return fetch.post('/common/advertiseInfoSave', data)
    },
    //引导词删除
    advertiseDelete(data) {
        return fetch.post('/common/advertiseDelete', data)
    },
    //系统配置信息
    systemManagement(data) {
        return fetch.post('/Finance/systemManagement', data)
    },
    //修改系统配置信息
    updateSystemManagement(data) {
        return fetch.post('/Finance/updateSystemManagement', data)
    },

    //首页分类列表
    homeCategoryList(data) {
        return fetch.post('/goods/homeCategoryList', data)
    },
    //修改首页分类
    homeCategoryUpdate(data) {
        return fetch.post('/goods/homeCategoryUpdate', data)
    },

    //审核入驻列表
    moderatedShopList(data) {
        return fetch.post('/shop/moderatedShopList', data)
    },
    //入驻审核
    moderatedShop(data) {
        return fetch.post('/shop/moderatedShop', data)
    },
    //店铺列表
    getShopList(data) {
        return fetch.post('/shop/getShopList', data)
    },
    //删除店铺
    shopDeleteStatus(data) {
        return fetch.post('/shop/shopDeleteStatus', data)
    },
    //修改汇率
    shopStatusUpdate(data) {
        return fetch.post('/shop/shopStatusUpdate', data)
    },
    //商品审核列表
    getGoodsPassList(data) {
        return fetch.post('/goods/getGoodsPassList', data)
    },

    //商户提现申请列表
    getShopBalanceLogList(data) {
        return fetch.post('/shop/getShopBalanceLogList', data)
    },
    //商户提现审核
    reviewShopWithdraw(data) {
        return fetch.post('/shop/reviewShopWithdraw', data)
    },
    // 轮播图列表
    lunboList(data) {
        return fetch.post('/Lunbo/lunboList', data)
    },
    // 添加轮播图
    Lunboadd(data) {
        return fetch.post('/Lunbo/add', data)
    },
    //删除轮播图
    Lunbodel(data) {
        return fetch.post('/Lunbo/del', data)
    },
    //修改轮播图状态
    setLunbostatus(data) {
        return fetch.post('/Lunbo/setLunbostatus', data)
    },

    //修改商品上架状态
    baseGoodsStatusUpdate(data) {
        return fetch.post('/goods/baseGoodsStatusUpdate', data)
    },
    //修改是否首页显示
    shopGoodsEditisInx(data) {
        return fetch.post('/goods/shopGoodsEditisInx', data)
    },
    //修改是否严选
    shopGoodsEditisyanxuan(data) {
        return fetch.post('/goods/shopGoodsEditisyanxuan', data)
    },

    //增值服务列表
    getServeList(data) {
        return fetch.post('/goods/getServeList', data)
    },
    //增值服务添加修改
    serveInfoSave(data) {
        return fetch.post('/goods/serveInfoSave', data)
    },
    //增值服务删除
    goodsServerDelete(data) {
        return fetch.post('/goods/goodsServerDelete', data)
    },
    //删除商品
    goodsDelete(data) {
        return fetch.post('/goods/goodsDelete', data)
    },
    //颜色删除
    delGoodsDetails(data) {
        return fetch.post('/goods/delGoodsDetails', data)
    },
    //操作规格删除
    delGoodsDetailsSon(data) {
        return fetch.post('/goods/delGoodsDetailsSon', data)
    },

    //用户提现列表
    memberWithdrawList(data) {
        return fetch.post('/member/memberWithdrawList', data)
    },
    //用户提现审核
    reviewUserWithdraw(data) {
        return fetch.post('/member/reviewUserWithdraw', data)
    },
    //商品审核列表
    // getGoodsPassList(data) {
    // 	return fetch.post('/goods/getGoodsPassList', data)
    // },
    //商品审核操作
    goodsReview(data) {
        return fetch.post('/goods/goodsReview', data)
    },
    //用户提现列表导出
    userWithdrawExcelExport(data) {
        return fetch.post('/member/userWithdrawExcelExport', data)
    },
    //商户提现列表导出
    shopWithdrawExcelExport(data) {
        return fetch.post('/shop/shopWithdrawExcelExport', data)
    },


    // 订单部分
    //天狼星风控
    getTianlanxingInfo(data) {
        return fetch.post('/Airdrop/getTianlanxingInfo', data)
    },
    //订单列表
    getOrderList(data) {
        return fetch.post('/order/getOrderList', data)
    },
    //订单详情
    orderdetail(data) {
        return fetch.post('/order/orderdetail', data)
    },
    //订单统计数
    tongjishu(data) {
        return fetch.post('/order/tongjishu', data)
    },
    //获取快递公司
    kuaidiGongsi(data) {
        return fetch.post('/order/express', data)
    },
    //发货
    orderfahuo(data) {
        return fetch.post('/order/fahuo', data)
    },

    //取消订单
    cancelOrder(data) {
        return fetch.post('/order/cancelOrder', data)
    },
    // 获取省市区
    getSheng(data) {
        return fetch.post('/Order/getSheng', data)
    },
    //修改收获地址
    modifyAddress(data) {
        return fetch.post('/order/modifyAddress', data)
    },
    //加入黑名单
    memberBlack(data) {
        return fetch.post('/Order/memberBlack', data)
    },
    //获取审核资料
    getShenhe(data) {
        return fetch.post('/Order/getShenhe', data)
    },
    //修改实名照片
    xiugaishiming(data) {
        return fetch.post('/Order/xiugaishiming', data)
    },
    //修改买断价
    xiuGaimaiduan(data) {
        return fetch.post('/order/maiduan', data)
    },


    //审核操作
    shenheStatus(data) {
        return fetch.post('/order/shenhe', data)
    },

	shenheStatus2(data) {
	    return fetch.post('/order/shenhe2', data)
	},

    //退押金操作
    tuiyajin(data) {
        return fetch.post('/order/tuiyajin', data)
    },

    //续租列表
    xuzulist(data) {
        return fetch.post('/order/xuzulist', data)
    },
    //审核续租列表
    shenhexuzu(data) {
        return fetch.post('/order/shenhexuzu', data)
    },

    //买断申请列表
    maiduanlist(data) {
        return fetch.post('/order/maiduanlist', data)
    },

    //买断申请列表审核
    shenhemaiduan(data) {
        return fetch.post('/order/shenhemaiduan', data)
    },
    //线下支付代扣
    xianxiaDaikou(data) {
        return fetch.post('/order/xianxia', data)
    },
    paymoney(data) {
        return fetch.post('/order/paymoney', data)
    },

    //查看物流
    lookPost(data) {
        return fetch.post('/Order/lookPost', data)
    },

    //修改押金
    edityj(data) {
        return fetch.post('/order/edityj ', data)
    },

    //自提确认收货
    writeOffWithdrawalCode(data) {
        return fetch.post('/Compensate/writeOffWithdrawalCode', data)
    },

    //查看归还物流
    lookBackPost(data) {
        return fetch.post('/Order/lookBackPost', data)
    },

    //归还验收
    yanshou(data) {
        return fetch.post('/order/yanshou', data)
    },

    // 订单账单
    orderSettlementRecord(data) {
        return fetch.post('/Compensate/orderSettlementRecord', data)
    },
    //退款账单
    refundRecord(data) {
        return fetch.post('/Compensate/refundRecord', data)
    },


    //、、、、、、、、、、、

    /***************************************************************************************/

    // //获取管理员日志
    // getAdminLog(data) {
    // 	return fetch.post('/admin/AdminLog/getAdminLog', data)
    // },


    // //修改管理员状态
    // modifyAdminRoleStatus(data) {
    // 	return fetch.post('/admin/AdminRole/modifyAdminRoleStatus', data)
    // },
    //删除角色列表
    delAdminRole(data) {
        return fetch.post('/manage/delAdminRole', data)
    },
    //删除角色某个权限
    delRoleMenu(data) {
        return fetch.post('/admin/AdminRole/delRoleMenu', data)
    },
    //删除管理员
    delAdmin(data) {
        return fetch.post('/manage/delAdmin', data)
    },
	delruzhu(data) {
	    return fetch.post('/manage/delruzhu', data)
	},
}


